import {
	LoginValues,
	SubmitStatus,
} from '@/components/views/unauthenticated/login/Login';
import { getErrorCodes } from '@/utils/utilities';
import { HttpStatusCode } from 'axios';
import httpClient from './httpClient';

type TokenResponse = {
	token: string;
	refreshToken: string;
};

abstract class UnauthenticatedApi {
	static login = async ({ email, password }: LoginValues) => {
		const response = await httpClient.post<TokenResponse>(`auth/login`, {
			email,
			password,
		});

		return response;
	};

	static refreshToken = async (refreshToken: string) => {
		const response = await httpClient.post<TokenResponse>(
			'auth/refresh',
			{},
			{
				headers: {
					Authorization: `Bearer ${refreshToken}`,
				},
			}
		);
		return response;
	};

	static verifyEmailToken = async (token: string) => {
		try {
			const response = await httpClient.post('users/verify', {
				token,
			});
			return response;
		} catch (error) {
			const message = getErrorCodes(error);
			return message;
		}
	};

	static checkIfEmailAvailable = async (email: string) => {
		try {
			const response = await httpClient.post('auth/register/check', { email });
			return response.status === HttpStatusCode.Created;
		} catch (error) {
			console.error(error);
			return false;
		}
	};

	static requestResetPassword = async (email: string) => {
		try {
			await httpClient.post('auth/forgot/password', {
				email,
				redirectUrl: `${import.meta.env.VITE_APP_URL}set-password`,
			});
			return SubmitStatus.SUCCESS;
		} catch (error) {
			const message = getErrorCodes(error);
			return { message };
		}
	};

	static resetPassword = async (hash: string, password: string) => {
		try {
			await httpClient.post('auth/reset/password', {
				hash,
				password,
			});
			return SubmitStatus.SUCCESS;
		} catch (error) {
			const message = getErrorCodes(error);

			return { message };
		}
	};

	static loginWithGoogle = async (idToken: string) => {
		const response = await httpClient.post<TokenResponse>(`auth/login/google`, {
			idToken,
		});

		return response;
	};

	static loginWithFacebook = async (idToken: string) => {
		const response = await httpClient.post<TokenResponse>(
			`auth/login/facebook`,
			{
				idToken,
			}
		);

		return response;
	};

	static logout = async () => {
		await httpClient.post('auth/logout', {});
		return 1;
	};
}

export default UnauthenticatedApi;
